import { Address } from 'viem';

import { Vault } from '@/features/vaults/types';
import { mezoCbBtcTokenAddress } from '@/features/vaults/constants/vaults/mezo/tokens/mezoCbBtcTokenAddress';
import { mezoCbBtcPreDepositVaultAddress } from '@/features/vaults/constants/vaults/mezo/mezo-cb-btc-vault-on-ethereum';

export const mezoCbBtcPreDepositVaultId = 'mezo-cbbtc-vault';

const mezoCbBtcVaultAddress: Address = '0x06ED1E2167AA7FBf2476c5A2D220Bf702559Dcf8';

export const mezoCbBtcVault: Vault = {
  migrations: [
    {
      network: 'ethereum',
      address: mezoCbBtcPreDepositVaultAddress,
      id: mezoCbBtcPreDepositVaultId,
    },
  ],
  id: mezoCbBtcPreDepositVaultId,
  type: 'core-vault',
  category: 'core-vault',
  name: 'Mezo cbBTC Vault',
  description:
    'Bring It Home to Mezo with Highest BTC Yield onchain this season. Curated Bitcoin yield vault by Sense.capital. Deposits are deployed into onchain liquidity strategies like Mezo Tigris, Uniswap V4, Curve and Yield Basis.\n' +
    '<br /><br />' +
    'Curator: Sense Capital — Quantitative fund specializing in institutional-grade DeFi strategies. Focus on IL-minimized, full-reserve, diversified yield across blue-chip venues',
  address: mezoCbBtcVaultAddress,
  network: 'mezo',
  networks: [
    {
      network: 'mezo',
      vaultAddress: mezoCbBtcVaultAddress,
    },
  ],
  curators: ['mezo', 'sense'],
  operator: [],
  baseToken: mezoCbBtcTokenAddress,
  depositTokens: [
    {
      address: mezoCbBtcTokenAddress,
      decimals: 8,
      symbol: 'cbBTC',
    },
  ],
  points: [{ entity: 'mellow', startTimestamp: 1760967575 }],
  lpTokenSymbol: 'mbhcbBTC',
  lpTokenDecimals: 18,
  allocations: {
    showAllocationsTab: false,
  },
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  isInstantDeposit: true,
};
